package com.schoolconnect.app.repository.auth

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.response.RequestOtpResponse
import com.schoolconnect.app.datasource.network.response.VerifyOtpResponse
import com.schoolconnect.app.util.scLog

/** Authentication orchestration boundary for auth/session ViewModels. */
object AuthRepository {
    private const val TAG = "[DATA_RETRIEVE_SC] AuthRepository"

    suspend fun requestOtp(email: String): Result<RequestOtpResponse> {
        val normalizedEmail = email.trim()
        if (normalizedEmail.isBlank()) {
            return Result.failure(IllegalArgumentException("email is required"))
        }
        scLog("$TAG requestOtp start")
        return KtorApiClient.requestOtp(normalizedEmail)
            .onSuccess { response ->
                scLog("$TAG requestOtp complete resendIn=${response.resendAvailableInSeconds}")
            }
            .onFailure { throwable -> scLog("$TAG requestOtp failure", throwable) }
    }

    suspend fun verifyOtp(email: String, otpCode: String): Result<VerifyOtpResponse> {
        val normalizedEmail = email.trim()
        val normalizedOtp = otpCode.trim()
        if (normalizedEmail.isBlank()) {
            return Result.failure(IllegalArgumentException("email is required"))
        }
        if (normalizedOtp.isBlank()) {
            return Result.failure(IllegalArgumentException("otpCode is required"))
        }
        scLog("$TAG verifyOtp start")
        return KtorApiClient.verifyOtp(normalizedEmail, normalizedOtp)
            .onSuccess { response ->
                scLog("$TAG verifyOtp complete user=${response.userId.ifBlank { "<blank>" }} profiles=${response.identityContextProfiles.size}")
            }
            .onFailure { throwable -> scLog("$TAG verifyOtp failure", throwable) }
    }

    suspend fun logout(): Result<Unit> {
        scLog("$TAG logout start")
        return KtorApiClient.logout()
            .onSuccess { scLog("$TAG logout complete") }
            .onFailure { throwable -> scLog("$TAG logout failure", throwable) }
    }
}
